exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js??ref--7-1!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../_general/lib/slim/slim.min.css"), "");

// module
exports.push([module.id, ".form-error[data-v-921c572e]{margin-top:0}", ""]);

// exports
